<template>
    <div class="ai-feedback">
        <CompassTooltip :content="translations.tooltip_label_like" placement="top">
            <CompassIconButton :icon="likeIcon" size="small" @click="handleLike" />
        </CompassTooltip>

        <CompassTooltip :content="translations.tooltip_label_dislike" placement="top">
            <CompassIconButton
                ref="dislikeIconRef"
                :icon="dislikeIcon"
                size="small"
                @click="handleDislike"
            />
        </CompassTooltip>
        <CompassPopover
            triggerRef="dislikeIconRef"
            :isVisible="showFeedbackPopover"
            :placement="placement"
            customClass="ai-feedback__popover"
            @close="showFeedbackPopover = false"
        >
            <div class="ai-feedback__popover-header">
                <div class="ai-feedback__popover-tag">
                    <CompassTagInteractive
                        v-for="(tag, index) in tags"
                        :key="index"
                        color="light-gray"
                        variant="selectable"
                        :modelValue="tag.label"
                        :isSelected="tag.selected"
                        :valueLabel="tag.label"
                        @change="selectTagFeedback(index)"
                    />
                </div>

                <CompassIconButton icon="close" @click="handleCloseIconPopover" />
            </div>

            <CompassInput
                ref="feedbackInput"
                v-model="messageFeedback"
                type="textarea"
                :placeholder="translations.textarea_placeholder"
                @keypress="onKeypressMessage"
            />
            <div class="ai-feedback__popover-button">
                <CompassButton
                    :label="translations.sendButton"
                    type="secondary"
                    :disabled="disabledFeedbackButton"
                    @click="handleValidateFeedback"
                />
            </div>
        </CompassPopover>
    </div>
</template>
<script>
export default {
    props: {
        tags: {
            type: Array,
            default: () => [],
        },
        placement: {
            type: String,
            default: 'bottom-start',
        },
        saveOnLike: {
            type: Boolean,
            default: false,
        },
        forceClose: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            translations: {
                tooltip_label_like: this.$t.__('ai.SellsyAILoadingDialog.tooltip_label_like'),
                tooltip_label_dislike: this.$t.__('ai.SellsyAILoadingDialog.tooltip_label_dislike'),
                textarea_placeholder: this.$t.__('ai.SellsyAILoadingDialog.textarea_placeholder'),
                sendButton: this.$t.__('common.actions.send'),
            },
            showFeedbackPopover: false,
            messageFeedback: '',
            isLiked: false,
            isDisliked: false,
        };
    },
    computed: {
        likeIcon() {
            return this.isLiked ? 'thumb-up-fill' : 'thumb-up';
        },
        dislikeIcon() {
            return this.isDisliked ? 'thumb-down-fill' : 'thumb-down';
        },
        disabledFeedbackButton() {
            return !this.messageFeedback && !this.tags.some((tag) => tag.selected);
        },
    },
    watch: {
        forceClose(newValue, oldValue) {
            if (oldValue !== null && newValue) {
                this.showFeedbackPopover = false;
            }
        },
    },
    methods: {
        onKeypressMessage(event) {
            const maxLength = 1000;
            if (event.target.value.length >= maxLength) {
                event.preventDefault();
            }
            this.$emit('keypress', this.messageFeedback);
        },
        selectTagFeedback(index) {
            this.$emit('tagSelected', index);
        },
        handleLike() {
            this.isLiked = !this.isLiked;
            this.isDisliked = false;
            this.$emit('reaction', this.isLiked ? 'like' : '');
            if (this.saveOnLike) {
                this.handleValidateFeedback();
            }
        },
        handleDislike() {
            this.isDisliked = !this.isDisliked;
            this.isLiked = false;
            this.$emit('reaction', this.isDisliked ? 'dislike' : '');
            this.showFeedbackPopover = this.isDisliked;
            this.$emit('visibleChange', this.showFeedbackPopover);
            this.$refs.feedbackInput?.$el.focus();
        },
        handleValidateFeedback() {
            this.showFeedbackPopover = false;
            this.$emit('saveFeedback', {
                messageFeedback: this.messageFeedback,
                isLiked: this.isLiked,
                isDisliked: this.isDisliked,
            });
        },
        handleCloseIconPopover() {
            this.handleValidateFeedback();
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-feedback {
    &__popover {
        width: 400px;

        &-header {
            display: flex;
            align-items: flex-start;
            margin: 0 0 var(--spacing-1);
        }

        &-tag {
            display: flex;
            flex-wrap: wrap;
            gap: var(--spacing-1);
        }

        &-button {
            display: flex;
            justify-content: flex-end;
            margin: var(--spacing-1) 0 0;
        }

        &:deep(.compass-input) {
            font-size: 14px;
            line-height: 20px;
        }
    }
}
</style>
